(function () {
    'use strict';
    angular.module('app').controller('CompaniesTableModalController', CompaniesTableModalController);
    CompaniesTableModalController.$inject = [
        '$uibModalInstance',
        'ClientService',
        'selectedCompaniesData',
        'OfficesTableService',
        'company'
    ];
    function CompaniesTableModalController(
        $uibModalInstance,
        ClientService,
        selectedCompaniesData,
        OfficesTableService,
        company
    ) {
        let vm = this;
        vm.companies = [];
        vm.getClients = getClients;
        vm.initOffice = initOffice;
        vm.closeModal = closeModal;
        vm.save = save;
        vm.disableDropdown = false;

        vm.officesTable = new OfficesTableService({ selectAll: selectAll });

        init();

        function init() {
            if (company) {
                vm.disableDropdown = true;
                vm.company = company.company ? angular.copy(company.company.value) : angular.copy(company);
                initOffice(vm.company.id);
            }
            else {
                vm.disableDropdown = false;
            }
        }

        function getClients(companyName) {
            ClientService.Company.getAll(data => {
                vm.companies = filterData(selectedCompaniesData, data.content);
            }, error => {
                toastr.error('Unable to fetch company list', error.message);
            }, { size: 200, name: companyName});
        }

        function initOffice(companyId) {
            vm.officesTable.updateData(companyId, company);
            vm.officesTableData = vm.officesTable.tableData;
        }

        function filterData(selectedData, dataToFilter) {
            if (angular.isDefined(selectedData) && selectedData !== null) {
                let data = dataToFilter.filter(value => {
                    let found = 0;
                    for (let i = 0; i < selectedData.length; i++) {
                        if (selectedData[i].id == value.id) {
                            found = 1;
                        }
                    }
                    return !found;
                });
                return data;
            }
            return dataToFilter;
        }

        function selectAll() {
            let newData = {
                selectedCompany: angular.copy(vm.company),
                offices: []
            };
            $uibModalInstance.close(newData);
        }

        function save() {
            let newData = {
                selectedCompany: angular.copy(vm.company),
                offices: vm.officesTable.selectedOffices()
            };
            $uibModalInstance.close(newData);
        }

        function closeModal() {
            $uibModalInstance.close();
        }
    }
})()



// WEBPACK FOOTER //
// ./js/controllers/services/add-ons/CompaniesTableModalController.js